export default __webpack_public_path__ + "static/media/identitätsraub.1603639c.jpg";